import React from 'react';
import local from 'services/localization/local';
import { ObservationType, Unit } from 'services/enums';
import { routePaths } from 'services/routing';
import { configIds } from 'health/observations/observation-config-ids';
import { baseObservationConfig } from 'health/observations/observation-config-helpers.jsx';
import { Waist } from 'shared/fullColorIcons';
import LogBodyWaist from './log/LogBodyWaist';

const typeDefinition = {
  type: ObservationType.BodyWaist,
  typeUnitMap: {
    [ObservationType.BodyWaist]: Unit.Inches
  },
  unitLabelMap: {
    [Unit.Inches]: local.units.inches
  }
};

export default {
  ...baseObservationConfig,
  ...typeDefinition,
  id: configIds.bodyWaist,
  backPath: { to: routePaths.health },
  centerElement: local.observation.bodyWaist.title,
  logcenterElement: local.observation.bodyWaist.logTitle,
  noDataText: local.observation.bodyWaist.noDataText,
  iconSymbol: Waist,
  renderLogComponent: (props) => props && <LogBodyWaist {...props} />
};
